/*
 * @Author: Claude
 * @Date: 2025-11-11
 * @Description: 文件大小单位转换工具函数
 */

import { FILE_SIZE_UNITS } from '../../constants';

/**
 * KB 转换为 Bytes
 * @param kb KB 大小
 * @returns Bytes 大小
 */
export const kbToBytes = (kb: number): number => {
  return kb * FILE_SIZE_UNITS.KB;
};

/**
 * Bytes 转换为 KB
 * @param bytes Bytes 大小
 * @returns KB 大小
 */
export const bytesToKb = (bytes: number): number => {
  return bytes / FILE_SIZE_UNITS.KB;
};

/**
 * MB 转换为 KB
 * @param mb MB 大小
 * @returns KB 大小
 */
export const mbToKb = (mb: number): number => {
  return mb * 1024;
};

/**
 * KB 转换为 MB
 * @param kb KB 大小
 * @returns MB 大小
 */
export const kbToMb = (kb: number): number => {
  return kb / 1024;
};

/**
 * 格式化文件大小显示
 * @param bytes 字节大小
 * @returns 格式化后的字符串（如: "10.5 MB", "512 KB"）
 */
export const formatFileSize = (bytes: number): string => {
  const kb = bytesToKb(bytes);

  if (kb < 1024) {
    return `${kb.toFixed(2)} KB`;
  }

  const mb = kbToMb(kb);
  if (mb < 1024) {
    return `${mb.toFixed(2)} MB`;
  }

  const gb = mb / 1024;
  return `${gb.toFixed(2)} GB`;
};
